import { Col, Divider, Row } from "antd";
import { useTranslation } from "react-i18next";
import FieldBuilder from "../../form-components/field-builder";
import { useWatch } from "react-hook-form";
import { getsponsorType } from "../../../models/discount-code/enum";
import { useContext, useEffect, useState } from "react";
import EndPoints from "../../../services/end-points";
import AppContext from "../../../context/app/context";
import { createActiveStoreFilter } from "../../../utils/helpers/store-filters";

export const ProviderDetailsSection = ({ control }) => {
    const { t } = useTranslation();

    const [companies, setCompanies] = useState<any[]>([]);
    const [companiesLoading, setCompaniesLoading] = useState<boolean>(true);
    const [specialStores, setSpecialStores] = useState<any[]>([]);
    const [specialStoresLoading, setSpecialStoresLoading] = useState<boolean>(true);
    const { direction } = useContext(AppContext);


    useEffect(() => {
        const getCompanies = async () => {
            try {
                const { data } = await EndPoints.trademark.getAllTrademark({
                    light: true,
                    perPage: -1,
                });
                setCompanies(data.data);
            } catch (error) {
                console.error('Error fetching companies:', error);
            } finally {
                setCompaniesLoading(false);
            }
        };
        getCompanies();
    }, [direction]);

    useEffect(() => {
        const getSpecialStores = async () => {
            try {
                const { data } = await EndPoints.store.getAllStores({
                    light: true,
                    perPage: -1,
                    filters: [createActiveStoreFilter()],
                });
                setSpecialStores(data.data);
            } catch (error) {
                console.error('Error fetching special stores:', error);
            } finally {
                setSpecialStoresLoading(false);
            }
        };
        getSpecialStores();
    }, [direction]);

    const sponsorType = useWatch({ control, name: "sponsorType" });
    return (
        <>
            <Divider orientation="center">{t("provider_details")}</Divider>
            <Row gutter={[16, 8]}>
                <Col span={12}>
                    <FieldBuilder
                        width="large"
                        name="sponsorType"
                        label={t("sponsor_type")}
                        input={{
                            type: "select",
                            options: [1, 2].map((type) => ({
                                value: type,
                                label: t(getsponsorType(type)),
                            })),
                        }}
                    />
                </Col>
                {sponsorType === 2 && (
                    <Col span={12}>
                        <FieldBuilder
                            name="companyId"
                            label={t("trademark")}
                            width="large"
                            rules={{ required: sponsorType === 2 }}
                            input={{
                                loading: companiesLoading,
                                type: "select",
                                options: companies.map((c) => ({ value: c.id, label: c.name })),
                            }}
                        />
                    </Col>
                )}
            </Row>
        </>
    );
};
